<div>
  <div class="modal-title">
    LO SENTIMOS
  </div>
  <div class="modal-body">
    <div class="error-label">
      <div style="align-self: center">
        <mat-icon>cancel</mat-icon>
      </div>
      Has superado la cantidad de reintentos.
    </div>
    <div class="error-info">
      Por favor comunícate con
      <span class="highlight">Servicio al Cliente</span> a través del
      <span class="highlight">800 222 100</span> o escríbenos a
      <a href="mailto:contactovida@security.cl">contactovida@security.cl</a>.
    </div>
    <div class="button-row">
      <button mat-stroked-button [mat-dialog-close]="true" class="close-button">
        Cerrar
      </button>
    </div>
  </div>
</div>
